export default "__VITE_ASSET__0I7RbxOU__"